import { render, staticRenderFns } from "./aboutIndex.vue?vue&type=template&id=7b93bed6&scoped=true&"
import script from "./aboutIndex.vue?vue&type=script&lang=js&"
export * from "./aboutIndex.vue?vue&type=script&lang=js&"
import style0 from "./css/index.css?vue&type=style&index=0&id=7b93bed6&scoped=true&lang=css&"
import style1 from "./aboutIndex.vue?vue&type=style&index=1&id=7b93bed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b93bed6",
  null
  
)

export default component.exports